<script setup lang="ts">
  import Sheet from '@/components/Sheet.vue'
  import { useProjectValidation } from '@/composables/validation/use-project-validation'
  import { useProjectStore } from '@/store/project.store'
  import { createEmptyProject, type Project } from '@/types/nest/projects'
  import { FormInput, useToastStore } from '@logistiek-zonder-papier/lzp-library'
  import { ref, watch } from 'vue'

  const MAX_PROJECT_NAME_LENGTH = 150

  const projectStore = useProjectStore()
  const toastStore = useToastStore()

  const show = defineModel<boolean>('show', { required: true })

  const project = ref<Project>(createEmptyProject())
  const submitting = ref<boolean>(false)

  const validation = useProjectValidation(project)

  const emit = defineEmits<{
    created: []
  }>()

  watch(
    () => show.value,
    () => {
      validation.submitted.value = false
      project.value = createEmptyProject()
    }
  )

  async function submit() {
    if (!validation.validate()) return
    submitting.value = true
    try {
      await projectStore.createProject(project.value)
    } catch (error) {
      toastStore.error('Error creating project:')
      throw error
    } finally {
      submitting.value = false
    }
    toastStore.success('Project succesvol aangemaakt')
    show.value = false
    emit('created')
  }
</script>

<template>
  <Sheet
    :is-open="show"
    title="Nieuw project"
    submit-label="Opslaan"
    :submit-disabled="submitting"
    @close="show = false"
    @submit="submit"
  >
    <FormInput
      v-model="project.name"
      label="Project naam"
      placeholder="Voer de project naam in"
      type="text"
      :error="validation.visibleErrors.value.name"
      :maxLength="MAX_PROJECT_NAME_LENGTH"
    />
  </Sheet>
</template>
